import {
  BlockTitle,
  Button,
  Card,
  CardContent,
  Col,
  List,
  ListInput,
  Row,
} from "framework7-react";
import * as React from "react";
import { API_URL, CLOUD_FUNCTION } from "src/utils/constants";
import { EventEmmiter } from "src/utils/events.js";
import { api } from "src/utils/utils";
import $ from "jquery";

interface IMenuTiendasProps {
  stores: any[]; // Define la forma del prop "stores"
}
export default class MenuTiendas extends React.Component<IMenuTiendasProps> {
  //   public componentDidMount() {}
  public state = {
    active: "todo" as string,
  };

  public render() {
    const { stores } = this.props; // Accede al valor del prop "stores"
    return (
      <div className="menuTiendas">
        <BlockTitle className="txt-center">Tiendas</BlockTitle>
        <ul>
          <li
            className={this.state.active === "todo" ? "active" : ""}
            onClick={() => {
              this.setStore("todo");
            }}
          >
            Todo
          </li>
          {stores.map((store) => (
            <li
              key={store}
              className={this.state.active === store.name ? "active" : ""}
              onClick={() => {
                this.setStore(store);
              }}
            >
              {store.name}
            </li>
          ))}
        </ul>

        <BlockTitle className="txt-center">Filtrar Ordenes</BlockTitle>
        <Row key="0" resizable={false} className="dashboard filter">
          <Col>
            <Card outline={true}>
              <CardContent>
                <div className="controls">
                  <div className="inputs">
                    <List>
                      <ListInput
                        outline
                        label="Buscar por ID, IDML o PACK ID"
                        floatingLabel
                        type="text"
                        id="idOrder"
                        className="invoice"
                        // defaultValue={order.invoice}
                      />

                      <ListInput
                        outline
                        label="Buscar por Remisión"
                        floatingLabel
                        type="text"
                        id="remission"
                        className="remission"
                        // defaultValue={order.remission}
                        placeholder=""
                      />

                      <ListInput
                        outline
                        label="Buscar por Factura"
                        floatingLabel
                        type="text"
                        id="invoice"
                        className="invoice"
                        // defaultValue={order.invoice}
                      />
                    </List>
                  </div>
                </div>
                <br />
                <Button
                  fill
                  color="blue"
                  raised
                  className="buttonSave"
                  onClick={() => {
                    this.searchBy();
                  }}
                >
                  Buscar
                </Button>
              </CardContent>
            </Card>
          </Col>

          <Col>
            <Card outline={true}>
              <CardContent>
                <div className="controls">
                  <div className="selects">
                    <List className="selects">
                      <ListInput
                        label="Estatus"
                        type="select"
                        // defaultValue={order.estatus ? order.estatus : "Abierto"}
                        className="estatus"
                        placeholder="Please choose..."
                        id="estatus"
                      >
                        <option value="">Seleccione una opción</option>
                        <option value="Abierto">⚪️ Abierto</option>
                        <option value="Completado">🟢 Completado</option>
                        <option value="Cancelado">🔴 Cancelado</option>
                      </ListInput>

                      <ListInput
                        label="¿Requiere factura?"
                        type="select"
                        className="is_invoice"
                        // defaultValue={
                        //   order.is_invoice ? order.is_invoice : "Nose"
                        // }
                        placeholder="Please choose..."
                        id="is_invoice"
                      >
                        <option value="">Seleccione una opción</option>
                        <option value="Nose">⚪️ Nose</option>
                        <option value="Male">🟢 Si</option>
                        <option value="Female">🔴 No</option>
                      </ListInput>

                      <ListInput
                        label="Datos"
                        type="select"
                        className="data_status"
                        // defaultValue={
                        //   order.data_status ? order.data_status : "N/A"
                        // }
                        placeholder="Please choose..."
                        id="data_status"
                      >
                        <option value="">Seleccione una opción</option>
                        <option value="N/A">⚪️ N/A</option>
                        <option value="Male">🟢 Si</option>
                        <option value="Female">🔴 Pendientes</option>
                      </ListInput>

                      {/* <ListInput
                        label="Por Fecha"
                        type="select"
                        className="data_date"
                        // defaultValue={
                        //   order.data_status ? order.data_status : "N/A"
                        // }
                        placeholder="Please choose..."
                        id="data_date"
                      >
                        <option value="">Seleccione una opción</option>
                        <option value="now">⚪️ HOY</option>
                        <option value="7">🟢 Últimos 7 días</option>
                        <option value="15">🟢 Últimos 15 días</option>
                        <option value="30">🟢 Últimos 30 días</option>
                        <option value="30">🟢 Desde Siempre</option>
                      </ListInput> */}
                    </List>
                  </div>
                </div>
                <br />
                <Button
                  fill
                  color="blue"
                  raised
                  className="buttonSave"
                  onClick={() => {
                    this.filterBy();
                  }}
                >
                  Filtrar
                </Button>
              </CardContent>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  public async searchBy() {
    const invoice = $("#invoice input").val();
    const remission = $("#remission input").val();
    const idOrder = $("#idOrder input").val();

    if (invoice === "" && remission === "" && idOrder === "") {
      return;
    }
    const dialog = this.$f7?.dialog.preloader("Buscando ordenes...");
    dialog?.open();

    const data = (await api.post(API_URL + CLOUD_FUNCTION + "searchBy", {
      invoice,
      remission,
      idOrder,
    })) as any;

    console.log("data", data);
    dialog?.close();

    // this.$f7?.popup.open("#ResultsOfSearch");
    EventEmmiter.dispatch("results", data);
  }

  public async filterBy() {
    const estatus = $("#estatus select").val();
    const isInvoice = $("#is_invoice select").val();
    const dataStatus = $("#data_status select").val();
    const dataDate = $("#data_date select").val();

    if (estatus === "" && isInvoice === "" && dataStatus === "") {
      return;
    }

    const dialog = this.$f7?.dialog.preloader("Filtrando ordenes...");
    dialog?.open();

    const data = (await api.post(API_URL + CLOUD_FUNCTION + "filterBy", {
      estatus,
      is_invoice: isInvoice,
      data_status: dataStatus,
      data_date: dataDate,
    })) as any;

    console.log("data", data);
    dialog?.close();

    // this.$f7?.popup.open("#ResultsOfSearch");
    EventEmmiter.dispatch("results", data);
  }

  private setStore(store: any) {
    $("#idOrder input, #remission input, #invoice input").val("");
    if (store === "todo") {
      this.setState({ active: "todo" });
      EventEmmiter.dispatch("change-store", "todo");
      //   console.log("todo");
    } else {
      this.setState({ active: store.name });
      EventEmmiter.dispatch("change-store", store.user_id);
    }
    console.log(store);
  }
}



// WEBPACK FOOTER //
// ./src/components/prefabs/MenuTiendas.tsx